import React, { useEffect } from "react";
import { Box, Typography, Button, Grid } from "@mui/material";
import { BrowserView, isBrowser, isMobile, MobileView } from "react-device-detect";
import { useTheme } from "@emotion/react";
import Popup from "./Popup.js";
import { useProject } from "../../hook/useProject.js";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";

const Title = ({ children, xs = 3 }) => {
  const theme = useTheme();
  return (
    <Grid item xs={xs}>
      <Typography color={theme.palette.primary.main} sx={{ fontWeight: 600 }}>
        {children}
      </Typography>
    </Grid>
  );
};

const Content = ({ children, xs = 3 }) => {
  return (
    <Grid item xs={xs}>
      <Typography>{children}</Typography>
    </Grid>
  );
};

const ProjectDetailsPopup = ({ open, onClose }) => {
  const theme = useTheme();
  const { projectId } = useParams();
  const project = useProject(projectId);

  const formatMemberString = (member) => {
    return <Typography key={member.userId}>{`${member.firstName} ${member.lastName} (${member.email}) - ${member.company}`}</Typography>;
  };

  return (
    <Popup
      open={open}
      onClose={onClose}
      title={"Project Details"}
      popupStyle={{
        minWidth: 800,
      }}
    >
      <Box p={4}>
        <Grid container spacing={1}>
          <Title>Project Name:</Title>
          <Content>{project?.projectName}</Content>
          <Title>Project Start Date:</Title>
          <Content>{project ? dayjs(project.startDate).format("DD/MM/YYYY") : ""}</Content>
          <Title>Project Number:</Title>
          <Content>{project?.projectNumber}</Content>
          <Title>Project End Date:</Title>
          <Content>{project ? dayjs(project.endDate).format("DD/MM/YYYY") : ""}</Content>
          <Title>Project Location:</Title>
          <Content xs={9}>{project?.location}</Content>
          <Title>Project Summary:</Title>
          <Content xs={9}>{project?.description}</Content>
          <Title xs={6}>Project Main Contact Person: </Title>
          <Title xs={6}>Project Companies: </Title>
          <Content xs={6}>
            {project?.members.filter((m) => m.userRole !== 4 && m.isPM && m.company === "CLP").map((m) => formatMemberString(m))}
          </Content>
          <Content xs={6}>{[...new Set(project?.contractors.map((m) => m.name))].join(" / ")}</Content>
          <Title xs={12}>Project Contractor PM: </Title>
          <Content xs={12}>{project?.members.filter((m) => m.userRole === 4 && m.isPM).map((m) => formatMemberString(m))}</Content>
          <Title xs={12}>Project Members: </Title>
          <Content xs={12}>{project?.members.filter((m) => !m.isPM).map((m) => formatMemberString(m))}</Content>
        </Grid>
      </Box>
    </Popup>
  );
};

export default ProjectDetailsPopup;
